import {AssistantInput} from '@stripe-internal/conversations-assistant';
import type {Conversation} from '@stripe-internal/conversations-client';

import {DotComChatInput} from './DotComChatInput';

type Props = {
  conversation: Conversation;
};

export function DotComAssistantInput({conversation}: Props) {
  return (
    <AssistantInput
      conversation={conversation}
      ChatInputComponent={DotComChatInput}
    />
  );
}
